module.exports = __webpack_public_path__ + "static/media/Sample_Question_Spreadsheet.11d84469.xlsx";